import {observer} from "mobx-react";
import React, {useState} from "react";
import User from "../../components/User";
import {PlayerStore} from "../rt/PlayerDrawer";
import {openStats} from "../exclusive_tt/Stats";

export default observer(({pl, withStats}) => {
  let {tournament} = gon;

  if (!pl)
    return null;

  let allow = (User.admin);
  if (allow && tournament)
    return <a onClick={e => {
      PlayerStore.open(pl.id);
      e.stopPropagation();
    }}>{pl.name}</a>

  if (withStats && tournament)
    return <a onClick={e => {
      openStats(null, pl.id);
      e.stopPropagation();
    }}>{pl.name}</a>

  return <b>{pl.name}</b>;
});